export default {
    lessonTopics: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js